// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://itcjwpvspbzbojqyiiqn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml0Y2p3cHZzcGJ6Ym9qcXlpaXFuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU2MTkwNDcsImV4cCI6MjA3MTE5NTA0N30.qbMa2k-8ncKQCpV6WHQ0-cS4aMOMUeTsdHMjjryeBAc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});